const servicesLinks = [
    // {
    //     id: 1, icon: 'icon-dexid', title: 'DexID', link: '/services'
    // },
    {
        id: 2, icon: 'icon-dexcloud', title: 'DexCloud', link: '/services'
    },
    {
        id: 3, icon: 'icon-dexpn', title: 'DexPN', link: '/services/dex-pn'
    },
    {
        id: 4, icon: 'icon-dexmobile', title: 'DexMobile', link: '/services/dex-mobile'
    },
    {
        id: 5, icon: 'icon-dexcards', title: 'DexCards', link: '/services/dex-cards'
    },
    {
        id: 6, icon: 'icon-dexpoint', title: 'DexPoint', link: '/services/dex-point'
    },
    {
        id: 7, icon: 'icon-dexsafe', title: 'DexSafe', link: '/services/dex-safe'
    }
];

export default servicesLinks;